import {
	Row,
	Col,
	Form,
	InputGroup,
	Dropdown,
	DropdownButton,
	FormControl,
	Button,
} from 'react-bootstrap';
import { useState } from 'react';

export const HazmatItem = ({
	id,
	currItem,
	commitChange,
	register,
	unregister = () => {},
	error,
	enableRemove = false,
	handleRemove = () => {},
}) => {
	const [item, setItem] = useState(currItem);

	function onCommonTradeNameChange(event) {
		const { value } = event.target;
		item.tradeName = value;
		setItem(item);
		commitChange(item, id);
	}

	function onChemicalNameChange(event) {
		const { value } = event.target;
		item.chemicalName = value;
		setItem(item);
		commitChange(item, id);
	}

	function onPhysicalStateChange(event) {
		const { value } = event.target;
		item.physicalState = value;
		setItem(item);
		commitChange(item, id);
	}

	function onAmountChange(event) {
		const { value } = event.target;
		item.quantity = value;
		setItem(item);
		commitChange(item, id);
	}

	function onUnitChange(unit) {
		item.unit = unit;
		setItem(item);
		commitChange(item, id);
	}

	return (
		<>
			<Row>
				<Form.Group as={Col} xs="12" md={6}>
					<Form.Label>Common Trade Name</Form.Label>
					<Form.Control
						type="text"
						value={item.tradeName}
						{...register(`inventory[${id}].tradeName`)}
						onChange={onCommonTradeNameChange}
					/>
					<Form.Text className="text-danger">
						{error.inventory?.[id]?.tradeName?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} xs={12} md={6}>
					<Form.Label>Chemical Name</Form.Label>
					<Form.Control
						type="text"
						value={item.chemicalName}
						{...register(`inventory[${id}].chemicalName`)}
						onChange={onChemicalNameChange}
					/>
					<Form.Text className="text-danger">
						{error.inventory?.[id]?.chemicalName?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Row>
				<Form.Group as={Col} xs={12} md={6}>
					<Form.Label className="pr-3">Physical State</Form.Label>
					<Form.Control
						as="select"
						xs="12"
						md="4"
						{...register(`inventory[${id}].physicalState`)}
						value={item.physicalState}
						onChange={onPhysicalStateChange}>
						<option value="gas">Gas/Vapor</option>
						<option value="liquid">Liquid</option>
						<option value="paste">Paste</option>
						<option value="solid">Solid</option>
					</Form.Control>
					<Form.Text className="text-danger">
						{error.inventory?.[id]?.physicalState?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} md={6}>
					<Form.Label>Maximum Quantity on Site</Form.Label>
					<InputGroup>
						<FormControl
							type="number"
							{...register(`inventory[${id}].quantity`)}
							value={item.quantity}
							onChange={onAmountChange}
						/>
						<DropdownButton
							as={InputGroup.Append}
							variant="outline-secondary"
							title={item.unit}
							id="input-group-dropdown-2">
							<Dropdown.Item onClick={() => onUnitChange('Cubic Feet')}>
								{' '}
								Cubic Feet{' '}
							</Dropdown.Item>
							<Dropdown.Item onClick={() => onUnitChange('Gallons')}>
								Gallons
							</Dropdown.Item>
							<Dropdown.Item onClick={() => onUnitChange('Pounds')}>
								Pounds
							</Dropdown.Item>
						</DropdownButton>
					</InputGroup>
					<Form.Text className="text-danger">
						{error.inventory?.[id]?.quantity?.message}
					</Form.Text>
				</Form.Group>
				{enableRemove === true && (
					<Button
						variant="outline-danger"
						className="deleteButton"
						onClick={() => {
							handleRemove(id);
							unregister(`inventory[${id}]`);
						}}>
						Remove Item
					</Button>
				)}
			</Row>
		</>
	);
};
